import { DualPriceProps } from '../models';

/**HRK is not available anywhere more from 01.01.2024.
 * We need to keep it in the system for the old proposals.
 */
export const CURRENCIES_WITH_DUAL_PRICING: DualPriceProps[] = [
  { currency: 'HRK', newCurrency: 'EUR', fixedExchangeRate: 0.13272281 },
];
